// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3JPGF","header":"MergedInvoice_header__168fT"};